import React, { useState } from "react";
import _ from "lodash";
import API from "../network/dashboardAPI";
import moment from "moment";

const CP_URL = process.env.REACT_APP_CP_URL

export const useOrderDetails = (orderId, trackingCodeFromQuery) => {
	const [details, setDetails] = useState(null);
	//package
	const [packageQuantity, setPackageQuantity] = useState("");
	const [packageWeight, setPackageWeight] = useState("");
	const [extShippingCost, setExtShippingCost] = useState("");
	const [extPackingCost, setExtPackingCost] = useState("");
	const [extShippingCostCurrency, setExtShippingCostCurrency] = useState("KHR");
	const [deliveryType, setDeliveryType] = useState(1);
	//tracking
	const [shipmentDetails, setShipmentDetail] = useState(null);
	const [trackingEvent, setTrackingEvent] = useState([]);
	const [trackingCode, setTrackingCode] = useState("");
	//courier
	const [courierCompanyList, setCourierCompanyList] = useState([]);
	const [courierCompany, setCourierCompany] = useState({label: "", value: ""});
	//slot
	const [slotHistoryModal, setSlotHistoryModal] = useState(false);
	const [statusHistories, setStatusHistories] = useState([]);
	const [deliveredHistories, setDeliveredHistories] = useState([]);
	const [slotHistories, setSlotHistories] = useState([]);
	const [dialogLoading, setDialogLoading] = useState(false);
	const [modalType, setModalType] = useState(null);
	const [getOrderId, setGetOrderId] = useState(null);
	const [deliveredAt, setDeliveredAt] = useState(null);
	const [showUpdateSchedule, setShowUpdateSchedule] = useState(false);
	const [selectedUpdateSlot, setSelectedUpdateSlot] = useState(0);
	const [showDeleteTrackingCode, setShowDeleteTrackingCode] = useState(false);
	const [updatingSlot, setUpdatingSlot] = useState(false)

	// State variables for payment modal and methods
	const [paymentModalOpen, setPaymentModalOpen] = useState(false);
	const [paymentNoteId, setPaymentNoteId] = useState("");
	const [deletePaymentModal, setDeletePaymentModal] = useState(false);
	const [paymentModalType, setPaymentModalType] = useState("add");

	// Driver Assignment State
	const [assignDriverModalOpen, setAssignDriverModalOpen] = useState(false);
	const PaymentType = {
		payment: "payment",
		refund: "refund",
	};
	const [formPaymentMethod, setFormPaymentMethod] = useState({
		date: moment().format("YYYY-MM-DD"),
		payment_method: '',
		type: PaymentType.payment,
		amount: '',
		comment: '',
		reason: '',
		order_id: '',
		cust_id: ''
	});

	const paymentNoteMethod = {
		WALLET: "Wallet",
		CASH: "Cash",
		ONLINE: "Online",
		BANK: "Bank Transfer",
		PAYMENT_LINK: "Payment Link",
		KESS: "Kess",
	};
	const [paymentReason, setPaymentReason] = useState(["Order payment", "Order Change", "Gratuity", "Other"]);
	const [paymentTypeReason] = useState(["Order payment", "Order Change", "Gratuity", "Other"]);
	const [refundReason] = useState(["Order Change", "Discount application", "Gratuity", "Other"]);
	const [orderSummery, setOrderSummery] = useState({
		driver_tip: 0,
		delivery_fee: 0,
		item_total: 0,
		order_total: 0,
		remaining_amount: 0,
		already_paid_amount: 0,
		payment_amount: 0
	})

	// Driver tip state
	const [driverTip, setDriverTip] = useState(0);
	const [initialDriverTip, setInitialDriverTip] = useState(0);
	const [isDriverTipSaving, setIsDriverTipSaving] = useState(false);

	// Delivery fee state
	const [deliveryFee, setDeliveryFee] = useState(0);

	// State variable for feedback messages
	const [feedback, setFeedback] = useState(null); // { variant, title, description }

	const showFeedbackMessage = (variant, title, description, autoHide = true, timeout = 3000) => {
		setFeedback({variant, title, description});
		if (autoHide) {
			setTimeout(() => setFeedback(null), timeout);
		}
	};

	/**
	 * Closes the feedback message.
	 */
	const closeFeedbackMessage = () => {
		setFeedback(null);
	};

	const fetchOrder = async () => {
		const response = await API.fetchOrderV2(orderId).then(res => res.json());
		if (response.success) {
			const data = response.data;
			// Set deliveryFee and driverTip BEFORE setDetails.
			// setDetails triggers OrderItemTable to mount; useOrderItems captures
			// initialDeliveryFee/initialDriverTip from details and compares against
			// these props. In React 17 each setState after await flushes a render
			// immediately, so these must be correct by the time details mounts the table.
			const tipValue = data?.order_payment_summery?.driver_tip || 0;
			setDriverTip(tipValue);
			setInitialDriverTip(tipValue);
			setDeliveryFee(data?.delivery_fee || 0);
			setDetails(data);
			setPackageWeight(data.package_weight);
			setPackageQuantity(data.package_quantity);
			setExtShippingCost(data.ext_shipping_costs);
			setExtPackingCost(data.ext_packing_costs);
			setExtShippingCostCurrency(data.ext_shipping_cost_currency || "KHR");
			setDeliveryType(data.external_courier);
			setCourierCompany({
				label: data?.courier_company,
				value: data?.courier_company
			});
			setOrderSummery(data?.order_payment_summery)
			setTrackingCode(data?.tracking_number);
			if (data?.tracking_number) {
				await handleTrackingCode("get", data?.tracking_number, data?.courier_company, data.cust_id)
			}
		}
	};

	const changeStatus = async (status) => {
		await API.changeOrderStatus({
			order_id: orderId,
			order_status: status,
			store_id: 1,
		});
		await fetchOrder();
	};

	const updateDeliveryType = async (external_courier) => {
		const response = await API.updateDeliveryType({order_id: orderId, external_courier}).then(res => res.json());
		if (response.success) setDeliveryType(external_courier);
		window.location.reload();
	};

	const getAllCourierCompany = async () => {
		await API.getAllCourierCompany()
			.then((res) => res.json())
			.then((res) => {
				const companies = res?.data?.items || [];
				let data = companies.map((e) => {
					return {
						label: e.name,
						value: e.name,
					};
				})
				setCourierCompanyList(data);
			});
	};

	const getUpdateHistories = async (order_id, page = 0, limit = 50) => {
		setDialogLoading(true);
		const body = {order_id, page: page + 1, limit};
		const res = await API.getUpdateSlotAndDeliveryAt(body).then(res => res.json());
		if (res.success) {
			const grouped = _.groupBy(res.data?.list || [], 'field');
			setStatusHistories(prev => [...prev, ...(grouped["order_status"] || [])]);
			setDeliveredHistories(prev => [...prev, ...(grouped["delivered_at"] || [])]);
			setSlotHistories(prev => [
				...prev,
				...(grouped["timeslot_start_time"] || []),
				...(grouped["timeslot_full_day"] || [])
			]);
		} else {
			alert(res.message);
		}
		setDialogLoading(false);
	};

	const handleShowUpdateSchedule = (id, deliveredAtTime) => {
		setShowUpdateSchedule(true);
		setGetOrderId(id);
		setDeliveredAt(deliveredAtTime);
	};

	const handleCloseDeliverySlotModal = () => {
		setShowUpdateSchedule(false);
		setGetOrderId(null);
	};

	const onUpdateSlotSelected = async (slotId, slot) => {
		setUpdatingSlot(true)
		const body = {
			order_id: getOrderId,
			slot_id: slotId,
			delivered_at: deliveredAt,
			slot_type: slot.type,
			slot_range: slot.slot_range,
		};
		const res = await API.updateSlotAndDeliveryAtByAdmin(body).then(res => res.json());
		if (res.success) {
			handleCloseDeliverySlotModal();
			setUpdatingSlot(false)
			await fetchOrder();
		} else {
			setUpdatingSlot(false)
			alert(res.message);
		}
	};

	const handleTrackingCode = async (getType = "get", tracking, courier_company = null, custId = null) => {
		let code = null;
		if (["Cambodia post"].includes(courier_company || courierCompany.label)) {
			code = (tracking || trackingCode)?.toUpperCase();
			if (!code) return;
		} else {
			code = tracking || trackingCode
		}
		setDialogLoading(true);
		const res = await API.findTrackingCode(code, {
			orderId,
			courierCompany: encodeURIComponent(courier_company || courierCompany.label),
			getType,
			custId: custId || details?.cust_id,
		}).then(res => res.json());
		if (res.success) {
			let packages = res?.shipment?.packages;
			setTrackingEvent(res.shipment.data);
			setPackageWeight(packages?.package_weight);
			setPackageQuantity(packages?.package_quantity);
			setExtShippingCost(packages?.ext_shipping_costs);
			setExtPackingCost(packages?.ext_packing_costs);
			setExtShippingCostCurrency(packages?.ext_shipping_cost_currency || "KHR");
		} else {
			alert(res.message);
		}
		setDialogLoading(false);
	};

	const handleDeleteTrackingCode = async (tracking_code) => {
		const code = (tracking_code || trackingCode).toUpperCase();
		if (!code) return;
		setDialogLoading(true);
		const res = await API.deleteTrackingCode(code, orderId).then(res => res.json());

		if (res.success) {
			setShowDeleteTrackingCode(false)
			setTrackingEvent([]);
			setTrackingCode("")
			setCourierCompany("")
		} else {
			alert(res.message);
		}
		setDialogLoading(false);
	};

	const createUpdateCourierCompany = async (e) => {
		const res = await API.createUpdateCourierCompany({
			order_id: orderId,
			courier_company: e.value,
		}).then(res => res.json());
		if (res.success) {
			setCourierCompany({label: e.value, value: e.value});
			showFeedbackMessage("success", "Success", "Your data has been saved.");
		} else {
			alert(res.message);
			showFeedbackMessage("error", "Failed", res.message);
		}
	};

	const handleSavePackage = async () => {
		setDialogLoading(true);
		const body = {
			package_quantity: packageQuantity,
			package_weight: packageWeight,
			ext_packing_costs: extPackingCost,
			ext_shipping_costs: extShippingCost,
			ext_shipping_cost_currency: extShippingCostCurrency,
			order_id: orderId,
		};
		const res = await API.createOrderShipmentPackage(body).then(res => res.json());
		if (!res.success) showFeedbackMessage("error", "Failed", res.message);
		setDialogLoading(false);
	};

	const handleOpenUpdateSlot = async (status, order, type = "") => {
		setSlotHistoryModal(status);
		setModalType(type)
		setDialogLoading(true);
		if (status === true) {
			await getUpdateHistories(order.order_id)
		}
	};

	const handleCloseUpdateSlot = async (status = false) => {
		setSlotHistoryModal(status);
		setStatusHistories([]);
		setDeliveredHistories([]);
		setSlotHistories([]);
	};

	const getStatus = (status) => {
		if (status === 2) return (<p>New</p>)
		else if (status === 3) return (<p>Accepted</p>)
		else if (status === 4) return (<p>Packed</p>)
		else if (status === 5) return (<p>Dispatched</p>)
		else if (status === 6) return (<p>Delivered</p>)
		else if (status === 7) return (<p>Cancelled</p>)
		else if (status === 8) return (<p>Arrived</p>)
		else if (status === 0) return (<p>Saved</p>)
		else if (status === 1) return (<p>Removed</p>)
	};

	const handleGoToCambodiaPost = () => {
		const url = trackingEvent[0]?.website;
		window.open(url, "_blank");
	};

	const getPrimary = (single, list) => single ?? list?.[0];

	const storeItem = (order) => getPrimary(order.store_item_info, order.store_item_infos);
	const storeItemPrice = (order) => getPrimary(order.store_item_info, order.store_items_price_types);
	const orderPayment = (details) => getPrimary(details.order_payment_detail, details.order_payment_details);
	const customer = (details) => getPrimary(details.customer_detail, details.customer_details);
	const address = (details) => getPrimary(details.list_customer_address, details.list_customer_addresses);

	/**
	 * Toggles the payment method modal.
	 *
	 * @param {string} [type="add"] - The type of modal (add or edit).
	 * @param {Object} [payment={}] - The payment details.
	 */
	const toggleNewPaymentMethodModal = (type = "add", payment = {}) => {
		setPaymentModalOpen(!paymentModalOpen);
		setPaymentModalType(type);
		if (type === "add") {
			setFormPaymentMethod({
				date: moment().format("YYYY-MM-DD"),
				payment_method: '',
				amount: '',
				comment: '',
				order_id: orderId,
				reason: '',
				type: PaymentType.payment,
				cust_id: details.cust_id || null,
			});
		} else {
			setFormPaymentMethod({
				payment_method: payment.payment_method,
				amount: payment.amount,
				comment: payment.comment,
				date: moment(payment.date).format("YYYY-MM-DD"),
				order_id: orderId,
				id: payment.id,
				type: payment.type,
				cust_id: details.cust_id || null,
				reason: payment.reason,
			});
		}
	};

	/**
	 * List of available payment methods.
	 */
	const paymentMethods = [
		{id: 1, title: 'Cash'},
		{id: 2, title: 'Wallet'},
		{id: 4, title: 'Bank Transfer'},
		{id: 5, title: 'Payment Link'},
		{id: 6, title: 'Kess'},
	];

	/**
	 * Checks if the payment method is a store payment method.
	 *
	 * @param {string} type - The type of payment method.
	 * @returns {boolean} - True if it is a store payment method, false otherwise.
	 */
	const storePaymentMethod = (type) => {
		return ["Wallet", "Cash", "Bank Transfer", "Payment Link", "Kess"].includes(type);
	};

	/**
	 * List of available payment types.
	 */
	const paymentType = [PaymentType.payment, PaymentType.refund];

	/**
	 * Handles adding or editing a payment method.
	 */
	const handleAddPaymentMethod = async () => {
		setDialogLoading(true);
		try {
			let response;
			if (paymentModalType === "edit") {
				response = await API.updateOrderPaymentNoted(formPaymentMethod.id, formPaymentMethod).then(res => res.json());
			} else {
				response = await API.createOrderPaymentNoted(formPaymentMethod).then(res => res.json());
			}
			if (response.success) {
				await fetchOrder();
				setPaymentModalOpen(false);
				showFeedbackMessage("success", "Success", `Payment method ${paymentModalType === "edit" ? "updated" : "added"} successfully.`);
				toggleNewPaymentMethodModal();
			} else {
				showFeedbackMessage("error", "Failed", response.message);
			}
		} finally {
			setDialogLoading(false);
		}
	};

	const handleDeletePaymentMethod = async () => {
		let response = await API.deleteOrderPaymentNoted(paymentNoteId).then(res => res.json());
		if (response.success) {
			await fetchOrder();
			setDeletePaymentModal(false);
			showFeedbackMessage("success", "Success", `Payment method has deleted.`);
		} else {
			showFeedbackMessage("error", "Failed", response.message);
		}
	};
	/**
	 * Handles changes to the payment method form.
	 *
	 * @param {Object} e - The event object containing form data.
	 */
	const handleChangeMethod = (e) => {
		const {name, value} = e.target;
		if (name === 'amount') {
			const numericValue = parseFloat(value);
			if (numericValue < 0) return; // block update
		}
		setFormPaymentMethod((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const calculateItemsTotal = (items = []) => {
		return items.reduce((total, item) => {
			const price = Number(item?.item_price) || 0;
			const quantity = Number(item?.quantity) || 1;
			return total + price * quantity;
		}, 0);
	};

	const calculateDeliveryFee = (order_delivery_fee) => {
		return Number(order_delivery_fee) || 0;
	};

	const calculateCouponDiscount = (wallet_discount_amount) => {
		return Number(wallet_discount_amount) || 0;
	};

	const calculateWalletDiscount = (wallet_discount_amount) => {
		return Number(wallet_discount_amount) || 0;
	};


	const calculateRemainingPayment = (total_to_pay, total_paid) => {
		return Number(total_to_pay) - Number(total_paid);
	};

	const calculatePaymentNote = (payments = []) => {
		let totalPaid = 0;

		payments.forEach((p) => {
			const amount = Number(p?.amount) || 0;
			const isPaid = Number(p?.is_paid) === 1;
			const paymentType = p?.payment_type;
			const type = p?.type; // 'payment' or 'refund'
			switch (paymentType) {
				case paymentNoteMethod.BANK:
				case paymentNoteMethod.PAYMENT_LINK:
				case paymentNoteMethod.KESS:
				case paymentNoteMethod.ONLINE:
					if (isPaid) {
						totalPaid += (type === 'refund' ? -amount : amount);
					}
					break;
				case paymentNoteMethod.CASH:
					totalPaid += (type === 'refund' ? -amount : amount);
					break;
				case paymentNoteMethod.WALLET:
					totalPaid += (type === 'refund' ? -amount : amount);
					break;

				default:
					// Unknown or unsupported payment type — ignore
					break;
			}
		});

		return totalPaid;
	};


	const calculateTotalToPayPayment = (itemTotal = 0, deliveryFee = 0, couponDiscount = 0) => {
		return Number(itemTotal) + Number(deliveryFee) - Number(couponDiscount);
	};

	const handleDriverTipChange = (newTip) => {
		setDriverTip(parseFloat(newTip) || 0);
	};

	const hasDriverTipChanges = parseFloat(driverTip || 0) !== parseFloat(initialDriverTip || 0);

	const handleDeliveryFeeChange = (newFee) => {
		setDeliveryFee(parseFloat(newFee) || 0);
	};

	const toggleAssignDriverModal = () => {
		setAssignDriverModalOpen(!assignDriverModalOpen);
	};

	const handleAssignDrivers = async (primaryId, secondaryId) => {
		setDialogLoading(true);
		try {
			// Update Primary Driver
			if (primaryId !== details.driver_id) {
				const res = await API.updateOrder({orderId: orderId}, {driver_id: primaryId}).then(r => r.json());
				if (!res.success) {
					showFeedbackMessage("error", "Failed to update primary driver", res.message);
				}
			}

			// Update Secondary Driver
			const currentSecondary = details.secondary_driver_id || details.secondaryDriver?.id;

			// If secondary driver has changed
			if (secondaryId !== currentSecondary) {
				// If selecting a new secondary driver (and it's not empty)
				if (secondaryId) {
					const res = await API.addSecondaryDriver({orderId: orderId}, {driver_id: secondaryId}).then(r => r.json());
					if (!res.success) {
						showFeedbackMessage("error", "Failed to update secondary driver", res.message);
					}
				}
				// If removing the secondary driver (new id is empty, but old one existed)
				else if (currentSecondary) {
					// We need to pass the OLD driver_id to remove it, based on valid API usage usually.
					// Checking order.js handleRemoveSecondaryDriver: body = { driver_id: selectedDriver } (which was the one to remove)
					// So we pass currentSecondary.
					const res = await API.removeSecondaryDriver({orderId: orderId}, {driver_id: currentSecondary}).then(r => r.json());
					if (!res.success) {
						showFeedbackMessage("error", "Failed to remove secondary driver", res.message);
					}
				}
			}

			await fetchOrder();
			setAssignDriverModalOpen(false);
			showFeedbackMessage("success", "Success", "Drivers updated successfully");
		} catch (error) {
			console.error("Error assigning drivers:", error);
			showFeedbackMessage("error", "Error", "An error occurred while updating drivers");
		} finally {
			setDialogLoading(false);
		}
	};

	return {
		state: {
			details,
			packageQuantity,
			packageWeight,
			extShippingCost,
			extPackingCost,
			extShippingCostCurrency,
			deliveryType,
			shipmentDetails,
			trackingEvent,
			trackingCode,
			courierCompanyList,
			courierCompany,
			slotHistoryModal,
			statusHistories,
			deliveredHistories,
			slotHistories,
			dialogLoading,
			modalType,
			getOrderId,
			deliveredAt,
			showUpdateSchedule,
			selectedUpdateSlot,
			showDeleteTrackingCode,
			updatingSlot,
			paymentModalOpen,
			paymentMethods,
			formPaymentMethod,
			paymentModalType,
			paymentType,
			deletePaymentModal,
			paymentNoteId,
			paymentReason,
			paymentTypeReason,
			refundReason,
			paymentNoteMethod,
			orderSummery,
			driverTip,
			deliveryFee,
			assignDriverModalOpen
		},
		setters: {
			setDetails,
			setGetOrderId,
			setShipmentDetail,
			setPackageQuantity,
			setPackageWeight,
			setExtShippingCost,
			setExtPackingCost,
			setExtShippingCostCurrency,
			setCourierCompany,
			setTrackingCode,
			setCourierCompanyList,
			setSlotHistoryModal,
			setStatusHistories,
			setDeliveredHistories,
			setSlotHistories,
			setDialogLoading,
			setModalType,
			setPaymentModalOpen,
			setFormPaymentMethod,
			setDeletePaymentModal,
			setPaymentNoteId,
			setPaymentReason,
			setShowDeleteTrackingCode,
			setOrderSummery,
			setDeliveryFee,
			setAssignDriverModalOpen
		},
		actions: {
			fetchOrder,
			changeStatus,
			updateDeliveryType,
			getAllCourierCompany,
			getUpdateHistories,
			handleShowUpdateSchedule,
			handleCloseDeliverySlotModal,
			onUpdateSlotSelected,
			handleTrackingCode,
			createUpdateCourierCompany,
			handleSavePackage,
			handleGoToCambodiaPost,
			getStatus,
			handleDeleteTrackingCode,
			handleOpenUpdateSlot,
			handleCloseUpdateSlot,
			toggleNewPaymentMethodModal,
			handleChangeMethod,
			handleAddPaymentMethod,
			storePaymentMethod,
			handleDeletePaymentMethod,
			calculatePaymentNote,
			calculateRemainingPayment,
			calculateTotalToPayPayment,
			calculateDeliveryFee,
			calculateCouponDiscount,
			calculateWalletDiscount,
			calculateItemsTotal,
			handleDriverTipChange,
			handleDeliveryFeeChange,
			toggleAssignDriverModal,
			handleAssignDrivers,
		},
		utils: {
			storeItem,
			storeItemPrice,
			orderPayment,
			customer,
			address
		},
		feedbackMessage: {
			feedback,
			closeFeedbackMessage
		}
	};
}
